import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import proposalsApi from '../../../APIs/proposals';
import {
  JobInformation,
  TechnicianProposalInformation,
} from '../../../components/TechnicianProposalDetails';
import { Divider, NavigateBack } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { requestAPI } from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';

type Props = {};

const ViewProposal = (_props: Props) => {
  const { technicianProposalId } = useParams();

  const ProposalDetails = useSelector(
    (state: RootState) => state.technicianProposalDetails,
  );
  console.log(ProposalDetails, 'proposal details');
  const getProposalDetails = async (id: string) => {
    try {
      await requestAPI(proposalsApi?.getTechnicianAllProposalById(id));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (technicianProposalId) {
      getProposalDetails(technicianProposalId);
    }
  }, []);
  return (
    <ViewJobContainerStyled>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div style={{ marginLeft: 30 }}>
        <TechnicianProposalInformation
          jobTitle={ProposalDetails?.job?.jobTitle || ''}
          cost={ProposalDetails?.cost || 0}
          experience={ProposalDetails?.numberOfExperience || ''}
          notes={ProposalDetails?.notes || ''}
          createdAt={ProposalDetails?.createdAt || ''}
          designApproach={ProposalDetails?.designApproach}
          qualification={ProposalDetails?.qualifications}
          riskAssessment={ProposalDetails?.riskAssessment}
          specification={ProposalDetails?.specification}
          status={ProposalDetails?.proposalStatus}
          pastClients={ProposalDetails?.pastClients || []}
        />
        <Divider />
        <JobInformation
          createdAt={ProposalDetails?.job?.createdAt || ''}
          jobTitle={ProposalDetails?.job?.jobTitle || ''}
          notes={ProposalDetails?.job?.notes}
          pricing={ProposalDetails?.job?.pricing}
          _id={ProposalDetails?.job?._id || ''}
        />
      </div>
    </ViewJobContainerStyled>
  );
};

export default ViewProposal;
